import { useRef } from "react"
import Marquee from "../marquee/marquee"
import isClientSide from "@utils/is-client-side"
import examples from "@content/examples.json"
import slugify from "slugify"

// slugify from dev hub
const fastlySlugify = (text) => {
  return slugify(text, { lower: true, remove: /[,:]/g }).replace(/'/g, "-")
}

export default function DevHubPromoAll() {
  const scrollingContent = useRef()

  const examplesbyIndustry = examples
    .filter((ex) => ex.promos && Object.values(ex.promos).some((x) => !!x))
    .flatMap((ex) =>
      Object.entries(ex.promos)
        .filter((item) => item[0] === "Video")
        .map(([label, title]) => ({
          link: `https://developer.fastly.com/solutions/examples/${fastlySlugify(ex.title)}`,
          label,
          title,
        }))
    )
    .sort(() => (Math.random() < 0.5 ? -1 : 1))

  // Split a list of examples into 3 lists. This is so we can animate 3 lanes on Desktop
  const countPerLane = 5
  const lanes = [
    examplesbyIndustry.splice(0, countPerLane),
    examplesbyIndustry.splice(0, countPerLane),
    examplesbyIndustry.splice(0, countPerLane),
  ]

  const animationSpeeds = [0.35, 0.43, 0.5]

  return (
    <div className="scrollingContent" ref={scrollingContent}>
      {isClientSide() &&
        lanes.map((recipes, i) => {
          return <Marquee root={scrollingContent} speed={animationSpeeds[i]} content={recipes} key={`lane-${i}`} />
        })}
    </div>
  )
}
